{
  "de": {
    "aiPrivacyNotice": {
      "backToChat": "Zurück zum KI-Chat",
      "pupil": {
        "facts": {
          "aiDoesNotKnowYou": "Die KI kennt dich nicht, solange du keine persönlichen Daten teilst.",
          "teacherCanSee": "Deine Lehrkraft kann sehen, was du machst und wer du bist."
        },
        "policyLink": "Mehr über Datenschutz lesen",
        "rules": {
          "doubtAnswers": "Ich glaube nicht alles, was die KI sagt.",
          "heading": "Zwei Regeln, wenn du die KI nutzt:",
          "noPrivateData": "Ich sage der KI nicht meinen echten Namen oder andere private Sachen."
        },
        "title": "So schützt du deine Daten"
      },
      "teacher": {
        "handling": {
          "detail": "Die Anbieter löschen Anfragen nach spätestens 30 Tagen.",
          "heading": "Wie deine Daten behandelt werden",
          "text": "Kein Training von KI-Modellen."
        },
        "intro": "Für eine Antwort sendet fobizz deine Eingabe an den KI-Dienstleister, den du ausgewählt hast.",
        "notTransmitted": {
          "detail": "Der Anbieter kann dich nicht identifizieren.",
          "heading": "Was wir nicht übermitteln",
          "text": "Name, E\u2011Mail, Nutzer\u2011ID, Schule oder IP\u2011Adresse."
        },
        "policyLink": "Zur vollständigen Datenschutzerklärung",
        "title": "Datennutzung durch KI-Dienste",
        "transmitted": {
          "detail": "(Bilder, Audio, PDF, Text)",
          "heading": "Was wir übermitteln",
          "text": "Deine Texte und hochgeladenen Dateien"
        }
      }
    }
  }
}
